import axios from 'axios';
import { useMutation } from '@tanstack/react-query';

export const unauthenticatedInstance = axios.create({
  baseURL: `${import.meta.env.VITE_API_URL}/api`,
});

export const useLogin = (
  onSuccess: (data: { access: string; refresh: string }) => void,
  onError: (error: Error) => void
) => {
  const login = async (email: string, password: string) => {
    const response = await unauthenticatedInstance.post('/token/', {
      email,
      password,
    });
    return response.data;
  };

  return useMutation({
    mutationFn: (data: { email: string; password: string }) =>
      login(data.email, data.password),
    onSuccess,
    onError,
  });
};

export const useRefreshToken = (
  onSuccess: (data: { access: string }) => void,
  onError: (error: Error) => void
) => {
  const refreshToken = async (token: string) => {
    const response = await unauthenticatedInstance.post('/token/refresh/', {
      refresh: token,
    });
    return response.data;
  };

  return useMutation({
    mutationFn: refreshToken,
    onSuccess,
    onError,
  });
};
